import { useState } from "react";
import { Link } from "react-router-dom";
import { IdentificationCard } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import AuthShell from "@/pages/AuthShell";

export default function ForgotUserId() {
  const [name, setName] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setResult(null); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-userid", { name });
      setResult(data);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Find Your Login ID" subtitle="Your login ID is the email on your account" testid="forgot-userid-page">
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-userid-form">
        <div className="space-y-1.5"><Label>Your Full Name</Label><Input required value={name} onChange={(e) => setName(e.target.value)} placeholder="As registered" data-testid="userid-name" /></div>
        {error && <div className="text-sm text-destructive" data-testid="userid-error">{error}</div>}
        <Button type="submit" disabled={loading} className="w-full rounded-full bg-primary hover:bg-[#113A64]" data-testid="userid-submit">{loading ? "Searching…" : "Find My Login ID"}</Button>
      </form>

      {result && (
        <div className="mt-6 rounded-md border border-border bg-muted p-4" data-testid="userid-result">
          <div className="flex items-center gap-2 text-primary"><IdentificationCard size={20} weight="duotone" className="text-accent" /><span className="text-sm font-medium">{result.message}</span></div>
          {result.email && <div className="font-mono text-lg text-primary mt-2">{result.email}</div>}
          {result.emails && <div className="mt-2 space-y-1">{result.emails.map((em) => <div key={em} className="font-mono text-sm text-primary">{em}</div>)}</div>}
          {result.found && <Link to="/login" className="inline-block mt-3 text-sm text-accent hover:underline">Continue to login →</Link>}
        </div>
      )}
    </AuthShell>
  );
}
